import { render, staticRenderFns } from "./RedirectorsTab.vue?vue&type=template&id=46e53f71&scoped=true&"
import script from "./RedirectorsTab.vue?vue&type=script&lang=js&"
export * from "./RedirectorsTab.vue?vue&type=script&lang=js&"
import style0 from "./RedirectorsTab.vue?vue&type=style&index=0&id=46e53f71&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e53f71",
  null
  
)

export default component.exports